import { RoamingInfo } from "@/services/model";
import { getTariffType, TariffTypes } from "@/utils/deviceUtils";

const getMaxVolume = (tariffType: TariffTypes) => {
  switch (tariffType) {
    case TariffTypes.flatMobileSwiss:
      // Flat Mobile One: 3 GB (3 * 1024 MB)
      return 3072;
    case TariffTypes.flatMobilePlus:
      // Flat Mobile Three: 50 GB (50 * 1024 MB)
      return 51200;
    case TariffTypes.flatMobile:
    default:
      // Flat Mobile Two: 20 GB (20 * 1024 MB)
      return 20480;
  }
};

export const useShouldDisplayRoamingHints = ({
  roamingInfo,
  serviceId,
}: {
  roamingInfo: RoamingInfo;
  serviceId?: number;
}) => {
  const tariffType = getTariffType(serviceId);

  // If the initial volume is less than x MB, we started the mobile abo somewhere in the middle of the month. In this case, we show a hint to the user explaining the odd volume.
  const shouldDisplayPartialHint =
    typeof roamingInfo.initialVolume === "number" &&
    roamingInfo.initialVolume < getMaxVolume(tariffType);

  return {
    shouldDisplayPartialHint,
  };
};
